import type { RelativeWorkspacePath } from "@codesandbox/pitcher-client";
import { usePitcher } from "features/utils/usePitcher";
import { useState } from "react";

import { useCapabilities } from "./useCapabilities";

export type FocusFileMessage = {
  type: "FOCUS_FILE";
  visibleLines: [number, number];
  currentLine: number;
  filepath: RelativeWorkspacePath;
};

export const useEditorChannel = () => {
  const pitcherCapabilities = useCapabilities();
  const pitcher = usePitcher();
  const [editorChannel] = useState(() =>
    pitcherCapabilities.channel?.subscribe
      ? pitcher.clients.channel.getCommandChannel<FocusFileMessage>("EDITOR")
      : null,
  );

  return editorChannel;
};
